import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import { Modal, Button, Form, Alert } from "react-bootstrap";
import axios from 'axios'
import "react-datepicker/dist/react-datepicker.css"
import { validateDepartmentEditForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";


export default class AddEventModel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      departmentName: "",
      id: null,
      loading: false,
      event: {},
      showAlert: false,
      errorMsg: "",
      done: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',

    };
  }

  componentDidMount() {
    this.setState({
      departmentName: this.props.data.departmentName,
      id: this.props.data.id
    })
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "departmentName" && value.trim()) {
      delete errors.departmentName;
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, () => {
      const errors = validateDepartmentEditForm(this.state.departmentName);

      if (Object.keys(errors).length > 0) {
        this.setState({ errors, loading: false });
        return;
      }

      let data = { departmentName: this.state.departmentName };

      axios({
        method: 'put',
        url: `/departments/${this.state.id}`,
        data: data,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
        .then((res) => {
          this.setState({
            done: true,
            toastMessage: "Department updated successfully!",
            toastVariant: 'success',
            color: 'green',
            showToast: true,
          });

          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 2000);
        })
        .catch((err) => {
          this.setState({
            showAlert: true,
            errorMsg: err.response?.data?.message || "Something went wrong!",
            toastMessage: "Department not updated successfully!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });

          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 2000);
        });
    });
  };


  render() {
    const { showAlert, done, errorMsg, loading } = this.state;
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />


        <CommonLoader isLoading={loading}>
          {done && <Redirect to="/departments" />}

          <Modal
            {...this.props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Update Department
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {/* {showAlert && (
                <Alert variant="warning" className="m-1">
                  {errorMsg}
                </Alert>
              )} */}

              <Form onSubmit={this.onSubmit}>
                <Form.Group controlId="formDepartmentName">
                  <Form.Label className="mb-2 required">
                    Department Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="col-12"
                    name="departmentName"
                    value={this.state.departmentName}
                    onChange={this.handleChange}
                    autoComplete="off"
                  />
                </Form.Group>
                {this.state.errors.departmentName && (
                  <small className="text-danger">
                    {this.state.errors.departmentName}
                  </small>
                )}
                <div className="edit-dept">
                  <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary mt-3" type="submit" >
                    {loading ? "Updating..." : "Update"}
                  </Button>
                  <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel mt-3"
                    onClick={this.props.onHide} >Close</Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </CommonLoader>
      </>
    );
  }
}